import { formatIsoString } from '@/utilities'

export function formatData(cisaKnownExploited, disclosureDate, exploits, publishedDate) {
  const data = []
  if (cisaKnownExploited) {
    const { added_date: addedDate, due_date: dueDate } = cisaKnownExploited
    data.push({
      id: 'cisaKnownExploited-1',
      x: formatIsoString(addedDate),
      y: 0,
      chartDescription: 'Date added to CISA Catalog',
      description: 'Date added to CISA Catalog',
    })
    data.push({
      id: 'cisaKnownExploited-2',
      x: formatIsoString(dueDate),
      y: 0,
      chartDescription: 'CISA Remediation date',
      description: 'CISA Remediation date',
    })
  }
  if (disclosureDate) {
    data.push({
      id: 'disclosureDate',
      x: formatIsoString(disclosureDate),
      y: 0,
      chartDescription: 'Date of Disclosure',
      description: 'Date of Disclosure',
    })
  }
  if (exploits && Array.isArray(exploits) && exploits.length > 0) {
    exploits.forEach(({ release_date: releaseDate, ...rest }, index) => {
      releaseDate && data.push({
        ...rest,
        x: formatIsoString(releaseDate),
        y: 0,
        chartDescription: 'Exploit Release Date',
        description: 'Exploit Release Date',
        id: `exploit-${index}`,
      })
    })
  }
  if (publishedDate) {
    data.push({
      id: 'publishedDate',
      x: formatIsoString(publishedDate),
      y: 0,
      description: 'First published date',
      chartDescription: 'First published date',
    })
  }
  const sorted = data.sort((a, b) => {
    return new Date(a.x) - new Date(b.x)
  })
  return [{
    id: 'VulnerabilityTimeline',
    data: sorted,
  }]
}
